import * as managers from 'app/mocks/data/park/managers/list'

import type { CategoryProduct } from 'app/types/catalogue/product/category'

export const subcategory1: CategoryProduct = {
    id: 1,
    name: 'Yaourts',
    client: managers.manager1,
    priority: 1,
}

export const subcategory2: CategoryProduct = {
    id: 2,
    name: 'Compotes',
    client: managers.manager1,
    priority: 2,
}

export const subcategory3: CategoryProduct = {
    id: 3,
    name: 'Crèmes Dessert',
    client: managers.manager1,
    priority: 3,
}

export const subcategory4: CategoryProduct = {
    id: 4,
    name: 'Eaux',
    client: managers.manager1,
    priority: 4,
}

export const subcategory5: CategoryProduct = {
    id: 5,
    name: 'Sodas',
    client: managers.manager1,
    priority: 5,
}

export const subcategory6: CategoryProduct = {
    id: 6,
    name: 'Jus de Fruits',
    client: managers.manager1,
    priority: 6,
}

export const subcategory7: CategoryProduct = {
    id: 7,
    name: 'Fruits Frais',
    client: managers.manager1,
    priority: 7,
}

export const subcategory8: CategoryProduct = {
    id: 8,
    name: 'Légumes Frais',
    client: managers.manager1,
    priority: 8,
}

export const subcategory9: CategoryProduct = {
    id: 9,
    name: 'Fruits Secs',
    client: managers.manager1,
    priority: 9,
}

export const subcategory10: CategoryProduct = {
    id: 10,
    name: 'Bœuf',
    client: managers.manager1,
    priority: 10,
}

export const subcategory11: CategoryProduct = {
    id: 11,
    name: 'Volaille',
    client: managers.manager2,
    priority: 1,
}

export const subcategory12: CategoryProduct = {
    id: 12,
    name: 'Porc',
    client: managers.manager2,
    priority: 2,
}

export const subcategory13: CategoryProduct = {
    id: 13,
    name: 'Poissons Frais',
    client: managers.manager2,
    priority: 3,
}

export const subcategory14: CategoryProduct = {
    id: 14,
    name: 'Fruits de Mer',
    client: managers.manager2,
    priority: 4,
}

export const subcategory15: CategoryProduct = {
    id: 15,
    name: 'Poissons Fumés',
    client: managers.manager2,
    priority: 5,
}

export const subcategory16: CategoryProduct = {
    id: 16,
    name: 'Lait',
    client: managers.manager3,
    priority: 1,
}

export const subcategory17: CategoryProduct = {
    id: 17,
    name: 'Beurre',
    client: managers.manager3,
    priority: 2,
}

export const subcategory18: CategoryProduct = {
    id: 18,
    name: 'Crème Fraîche',
    client: managers.manager3,
    priority: 3,
}

export const subcategory19: CategoryProduct = {
    id: 19,
    name: 'Pain Frais',
    client: managers.manager3,
    priority: 4,
}

export const subcategory20: CategoryProduct = {
    id: 20,
    name: 'Viennoiseries',
    client: managers.manager3,
    priority: 5,
}

export const subcategory21: CategoryProduct = {
    id: 21,
    name: 'Gâteaux',
    client: managers.manager4,
    priority: 1,
}

export const subcategory22: CategoryProduct = {
    id: 22,
    name: 'Chips',
    client: managers.manager4,
    priority: 2,
}

export const subcategory23: CategoryProduct = {
    id: 23,
    name: 'Crackers',
    client: managers.manager4,
    priority: 3,
}

export const subcategory24: CategoryProduct = {
    id: 24,
    name: 'Biscuits Apéritifs',
    client: managers.manager4,
    priority: 4,
}

export const subcategory25: CategoryProduct = {
    id: 25,
    name: 'Chocolat',
    client: managers.manager4,
    priority: 5,
}

export const subcategory26: CategoryProduct = {
    id: 26,
    name: 'Biscuits',
    client: managers.manager5,
    priority: 1,
}

export const subcategory27: CategoryProduct = {
    id: 27,
    name: 'Bonbons',
    client: managers.manager5,
    priority: 2,
}

export const subcategory28: CategoryProduct = {
    id: 28,
    name: 'Plats Préparés Surgelés',
    client: managers.manager5,
    priority: 3,
}

export const subcategory29: CategoryProduct = {
    id: 29,
    name: 'Légumes Surgelés',
    client: managers.manager5,
    priority: 4,
}

export const subcategory30: CategoryProduct = {
    id: 30,
    name: 'Glaces',
    client: managers.manager5,
    priority: 5,
}
